import _ from 'lodash';
import copyText from 'copy-to-clipboard';
import { message } from 'antd';

// Regex to validate URL
const urlPattern = /^(ftp|http|https):\/\/[^ "]+\.[^ "]+$/;

// Regex to validate telephone number link
const phoneRegexPattern = /^tel:\+?\d{1,4}[\s.-]?\(?\d{1,4}\)?[\s.-]?\d{1,4}[\s.-]?\d{1,4}$/;

// Regex to validate mail link
const mailtoRegexPattern = /^mailto:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isValidUrlFormat = (url) => {
  return urlPattern.test(url) || phoneRegexPattern.test(url) || mailtoRegexPattern.test(url);
};

export const urlMatch = (url) => {
  return url.match(urlPattern) || url.match(phoneRegexPattern) || url.match(mailtoRegexPattern);
};

export const copySelectedLink = (link) => {
  copyText(link);
  message.success('Copied to Clipboard');
};

// get the style to render hyperlink input modal
export const getLinkInputStyle = (state, numberOfColumns = 1, columnIndex = 0) => {
  const style = _.extend({}, state.currentCursorOffset.position);
  style.top = style.top > 30 ? style.top + 65 : 30;

  // prevent going away from screen in left
  if (style.left < -40) {
    style.left = -40;
  }

  // prevent going out of screen on right
  if (numberOfColumns === 1) {
    if (style.left > 200) {
      delete style.left;
      style.right = -38;
    }
  } else if (numberOfColumns === 2 && columnIndex === 0) {
    style.left = Math.min(style.left, 170);
  } else if (
    (numberOfColumns === 4 && columnIndex === 2) ||
    (numberOfColumns === 3 && columnIndex === 1)
  ) {
    style.left = -98;
  } else if (
    (numberOfColumns === 4 && columnIndex === 3) ||
    (numberOfColumns === 3 && columnIndex === 2) ||
    (numberOfColumns === 2 && columnIndex === 1)
  ) {
    delete style.left;
    style.right = -38;
  }

  return style;
};
